import styled from 'styled-components';

import Heading from 'components/common/Typography/Heading';
import Text from 'components/common/Text';
import Link from 'components/common/Link';

export interface IProps {
  mb?: number;
  mt?: number;
  pt?: number;
  pb?: number;
  isContactInfoExists?: boolean;
}

export const ProfileDetailsDescriptionWrapper = styled.div<IProps>`
  width: 100%;
  height: auto;
  min-height: '110px';
  max-height: '2000px';
  transition-duration: 1s;
  overflow: hidden;
  background: ${(props) => props.theme.colors.white};
  box-shadow: ${(props) => props.theme.colors.shadows.sm};
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  padding-bottom: '45px';

  align-items: center;
  position: relative;
`;

export const GeneralInfo = styled.div<IProps>`
  width: 94%;
  padding-bottom: ${({ pb }) => (pb ? `${pb}px` : '0')};
  border-bottom: '1px solid #e3e3e3';
`;

export const HeaderText = styled(Heading)<IProps>`
  font-weight: ${(props) => props.theme.typography.fontWeight.semiBold};
  font-size: ${(props) => props.theme.typography.fontSize.f6};
  line-height: 150%;
  width: 100%;
  letter-spacing: 0.02em;
  color: ${(props) => props.theme.colors.black};
  padding-top: 16px;
  margin-bottom: ${({ mb }) => (mb ? `${mb}px` : '0')};
  margin-top: ${({ mt }) => (mt ? `${mt}px` : '0')};
`;

export const GeneralInfoDescription = styled.div<IProps>`
  height: 'auto';
  overflow: hidden;
  font-size: ${(props) => props.theme.typography.fontSize.f4};
  line-height: 150%;
  letter-spacing: 0.01em;
  color: ${(props) => props.theme.colors.black};
`;

export const ContactInfoBlock = styled.div<IProps>`
  display: flex;
  flex-direction: column;
  height: auto;
  width: 94%;
  word-wrap: break-word;
  overflow-wrap: break-word;
  margin-top: ${({ isContactInfoExists }) =>
    isContactInfoExists ? '16px' : '0'};
  transition: 1s, height 2s;
  opacity: '1';
  height: 'auto';
  visibility: 'visible';
`;

export const ContactInfoItemWrap = styled.div`
  display: flex;
  align-items: flex-start;
  margin-bottom: 16px;
`;

export const ContactInfoItemText = styled(Text)`
  font-size: ${(props) => props.theme.typography.fontSize.f4};
  font-weight: ${(props) => props.theme.typography.fontWeight.regular};
  line-height: 16px;
  letter-spacing: 0.02em;
  color: ${(props) => props.theme.colors.black};
  margin-left: 12px;
  margin-top: 5px;
`;

export const ContentInfoItemIconWrap = styled.div`
  width: 24px;
  height: 24px;
  min-width: 24px;
`;

export const LinkWrap = styled(Link)`
  text-decoration: none;
  color: ${(props) => props.theme.colors.black};
  cursor: pointer;
  display: inline-block;
`;

export const BottomLine = styled.div<IProps>`
  display: flex;
  width: 100%;
  padding-top: ${({ pt }) => (pt ? `${pt}px` : '0')};
  border-bottom: 1px solid #e3e3e3;
`;

export const PillWrapBrands = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 8px;
  padding-bottom: 16px;
`;

export const MyBrands = styled.div<IProps>`
  width: 94%;
  flex-direction: column;
  position: relative;
  transition: 1s, height 2s;
  opacity: '1';
  height: 'auto';
  visibility: 'visible';
`;

export const MyCollaborators = styled.div<IProps>`
  width: 94%;
  margin-bottom: 16px;
  transition: 1s, height 2s;
  opacity: '1';
  height: 'auto';
  visibility: 'visible';

  & > div {
    &:nth-child(2) {
      border: none;
      padding: 0;
      & > div {
        & > div {
          &:first-child {
            display: none;
          }
        }
      }
    }
  }
`;

export const MyInterestBlock = styled.div<IProps>`
  width: 94%;
  transition: 1s, height 2s;
  opacity: '1';
  height: 'auto';
  visibility: 'visible';
  flex-direction: column;

  p {
    position: relative;

    margin-bottom: 20px;
  }
`;

export const PillWrap = styled.div`
  width: 100%;
  margin-top: 8px;
  padding-bottom: 16px;
`;
